import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchUpcomingBookings } from "../../../../features/bookings/bookingThunks";
import "./MyBookings.css";

const MyBookings = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { list, loading } = useSelector((state) => state.bookings);

  useEffect(() => {
    dispatch(fetchUpcomingBookings({ page: 1, limit: 20 }));
  }, [dispatch]);

  if (loading) return (
    <div className="bk-status-container">
      <div className="bk-spinner"></div>
      <p>Loading your bookings...</p>
    </div>
  );

  return (
    <div className="bk-container">
      <header className="bk-page-header">
        <div>
          <h2 className="bk-title">My Bookings</h2>
          <p className="bk-subtitle">You have {list.length} upcoming sessions</p>
        </div>
      </header>

      {list.length > 0 ? (
        <div className="bk-grid">
          {list.map((b) => (
            <div key={b._id} className="bk-card">
              <div className="bk-header">
                <span className="bk-type-badge">{b.bookingType}</span>
                <span className="bk-status-paid">● Paid</span>
              </div>

              <div className="bk-body">
                <h4 className="bk-date-text">{b.week || b.date}</h4>
                <p className="bk-slot-text">Slot #{b.slotNumber}</p>
                <code className="bk-id-badge">ID: {b.bookingId.slice(0, 10)}</code>
              </div>

              <div className="bk-footer">
                <div className="bk-price-section">
                  <span className="bk-label">Total Amount</span>
                  <span className="bk-amount">₹{b.totalAmount}</span>
                </div>
                <button
                  className="bk-btn-primary"
                  onClick={() => navigate(`/dashboard/booking-details/${b._id}`)}
                >
                  View Details
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="bk-empty-state">
          <p>No upcoming bookings found.</p>
        </div>
      )}
      <style>
        {`:root {
  --primary: #463B7F;
  --primary-hover: #3932c3ff;
  --bg-subtle: #f9fafb;
  --text-main: #111827;
  --text-muted: #6b7280;
  --success: #10b981;
}

.bk-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 16px;
}

.bk-page-header {
  margin-bottom: 32px;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 16px;
}

.bk-title {
  font-size: 28px;
  color: var(--text-main);
  font-weight: 700;
  margin: 0;
}

/* Grid System */
.bk-grid {
  display: grid;
  gap: 20px;
  /* Responsive columns */
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}

.bk-card {
  background: #ffffff;
  border: 1px solid #f3f4f6;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.bk-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.bk-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.bk-type-badge {
  background: #eef2ff;
  color: var(--primary);
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 6px;
  letter-spacing: 0.5px;
}

.bk-status-paid {
  font-size: 12px;
  color: var(--success);
  font-weight: 600;
}

.bk-body {
  margin-bottom: 20px;
}

.bk-date-text {
  font-size: 18px;
  margin: 0 0 4px 0;
  color: var(--text-main);
}

.bk-slot-text {
  color: var(--text-muted);
  margin: 0 0 8px 0;
}

.bk-id-badge {
  font-size: 11px;
  background: var(--bg-subtle);
  padding: 2px 6px;
  border-radius: 4px;
  color: var(--text-muted);
}

.bk-footer {
  margin-top: auto;
  border-top: 1px dashed #e5e7eb;
  padding-top: 16px;
}

.bk-price-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.bk-label {
  font-size: 13px;
  color: var(--text-muted);
}

.bk-amount {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-main);
}

.bk-btn-primary {
  width: 100%;
  background: var(--primary);
  color: white;
  border: none;
  padding: 12px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.bk-btn-primary:hover {
  background: var(--primary-hover);
}

/* Loader Styles */
.bk-status-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0;
  color: var(--text-muted);
}

.bk-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f4f6;
  border-top: 4px solid var(--primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`}
      </style>
    </div>
  );
};

export default MyBookings;